module.exports = __webpack_public_path__ + "static/media/InfoIcon.c5d2a3e9.svg";